import { render, staticRenderFns } from "./central-config-step-guide.vue?vue&type=template&id=4064a999&scoped=true&"
import script from "./central-config-step-guide.vue?vue&type=script&lang=js&"
export * from "./central-config-step-guide.vue?vue&type=script&lang=js&"
import style0 from "./central-config-step-guide.vue?vue&type=style&index=0&id=4064a999&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064a999",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4064a999')) {
      api.createRecord('4064a999', component.options)
    } else {
      api.reload('4064a999', component.options)
    }
    module.hot.accept("./central-config-step-guide.vue?vue&type=template&id=4064a999&scoped=true&", function () {
      api.rerender('4064a999', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/central-config/components/central-config-step-guide.vue"
export default component.exports